var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.textareaStyle])
  var g0 = _vm.$u.addUnit(_vm.height)
  var g1 = _vm.$u.addStyle(_vm.placeholderStyle, "string")
  var g2 = _vm.count ? _vm.innerValue.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        g1: g1,
        g2: g2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }